/* ***************************************************************** */
/*                                                                   */
/* Licensed Materials - Property of Merative                         */
/*                                                                   */
/* (C) Copyright Merative Corp. 2025                                 */
/*                                                                   */
/* ***************************************************************** */
import React from 'react';

export const TitleHeader = ({ mainTitle, subTitle, id = "" }) => {
  return (
    <div id={id} className="mdx-header border-line">
      <h1 className="search-and-results-page-titles neofax-search-page-header heading-color heading-font">
        <div className="header-label">{subTitle}</div>
        {mainTitle}
      </h1>
    </div>
  );
};